import React from 'react';

/** Placeholder route for PayFast notify_url (ITN requires a server endpoint later). */
const PaymentNotify: React.FC = () => (
  <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
    <p className="text-gray-600 text-center">
      Payment notification endpoint. PayFast server callbacks must be configured separately.
    </p>
  </div>
);

export default PaymentNotify;
